import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiOutlineTwitter, AiFillFacebook } from "react-icons/ai";
// import { FaLinkedinIn } from "react-icons/fa";
import { SiLeetcode } from "react-icons/si";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Since learning programming and exposing myself to technology, I
              have gained a perspective on how the world works, I think… 🤷‍♂️{" "}
              <br />
              I have developed a deep passion for building solutions that
              address real-world challenges 🚀
              <br />
              <br />
              My primary focus is on leveraging{" "}
              <i>
                <b className="purple">
                  Artificial Intelligence & Machine Learning
                </b>
              </i>{" "}
              to create innovative solutions with unlimited potential. I'm also
              deeply interested in{" "}
              <b className="purple">Blockchain Technology</b> for building
              secure, decentralized systems.
              <br />
              <br />
              <b className="purple">
                I'm passionate about building startups that solve real problems
                and make a meaningful impact.
              </b>{" "}
              With my expertise in{" "}
              <i>
                <b className="purple">Modern Software Development</b>
              </i>
              &nbsp;and understanding of{" "}
              <i>
                <b className="purple">Business Strategy</b>
              </i>
              , I strive to create solutions that are both technically excellent
              and commercially viable.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/vamnguyen"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/anhminhdev"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/vamnguyen/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li> */}
              <li className="social-icons">
                <a
                  href="https://www.facebook.com/nvanhminh9"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://leetcode.com/u/vamnguyen/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <SiLeetcode />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
